import React, {useState} from 'react';
import {Icon, Modal, Grid, Table} from 'semantic-ui-react';

const TrackingTechDetailsModal = () => {
  const [showModal, setShowModal] = useState(false);

  const showModalClick = (e, value) => {
    e.preventDefault();
    setShowModal(value);
  };

  return (
    <Modal open={showModal}
      size='small'
      trigger={
        <Icon name='info circle' size='large' color='blue' link
          onClick={(e) => showModalClick(e, true)}
          style={{'marginLeft': '8px', 'verticalAlign': 'middle'}} />
      }>
      <Modal.Header>
        <div className='header flex'>
          <h2 className='flex grow' style={{'margin': 0}}>
            Detalles Técnicos: Seguimiento de Pedidos
          </h2>
          <Icon name='close' style={{'margin': 0, 'cursor': 'pointer'}}
            onClick={(e) => showModalClick(e, false)} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <Grid celled>
          <Grid.Row>
            <Grid.Column width={3}><strong>Frontend</strong></Grid.Column>
            <Grid.Column width={13}>
              /src/dealerOrders/tracking
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}><strong>Backend</strong></Grid.Column>
            <Grid.Column width={13}>
              <div><strong>GET</strong> /api/dealer-orders/administration - Consulta pedidos</div>
              <div><strong>POST</strong> /api/dealer-orders/administration - Crear pedidos / Exportar Excel</div>
              <div><strong>PUT</strong> /api/dealer-orders/administration - Actualizar pedidos</div>
              <div><strong>DELETE</strong> /api/dealer-orders/administration - Eliminar/Rechazar pedidos</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}><strong>BDD</strong></Grid.Column>
            <Grid.Column width={13}>
              <div>REP_PEDIDOS_CONCESIONARIOS - Pedidos normales</div>
              <div>CODIGOS_RPA - Datos RPA para cálculo de ETA</div>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={16}>
              <h3 style={{'marginBottom': '10px'}}>Catálogo de Condiciones - Mensajes ETA</h3>
              <Table celled structured>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Mensaje</Table.HeaderCell>
                    <Table.HeaderCell>Cuándo se muestra</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  <Table.Row>
                    <Table.Cell><strong>Calculando ETA</strong></Table.Cell>
                    <Table.Cell>
                      El pedido acaba de crearse y el sistema está calculando
                      el ETA en segundo plano (primeros 60 segundos)
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell><strong>Fuente diferente</strong></Table.Cell>
                    <Table.Cell>El código de parte no existe en la tabla CODIGOS_RPA</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell><strong>Stock: 0</strong></Table.Cell>
                    <Table.Cell>
                      El código existe en CODIGOS_RPA y el stock no es mayor
                      a 0. Se suman los días de leadtime al ETA
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row positive>
                    <Table.Cell><strong>Leadtime: {'{días}'}</strong></Table.Cell>
                    <Table.Cell>
                        El código existe en CODIGOS_RPA y
                        el stock es mayor a 0. Se suman los días de leadtime al ETA
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  );
};

export default TrackingTechDetailsModal;
